import useDocumentTitle from "hooks/useDocumentTitle";
import Head from "view/components/Head";

const PageHeading = ({ id, name }: any) => {
  return (
    <div className="flex flex-col justify-start items-start flex-grow py-0.5">
      <Head title={id ? `${name}: Quality Assurance` : "Quality Assurance"} />
      <div className="relative flex items-center self-stretch justify-start flex-grow-0 flex-shrink-0">
        <p className="break-all w-full text-[28px] font-bold text-left text-textMid dark:text-textMain">
          {id ? `${name}: Quality Assurance` : "Quality Assurance"}
        </p>
      </div>
    </div>
  );
};

export { PageHeading };
